import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { DrawerNav } from "./DrawerNav";

export const Navigation = () => {
  const { isLoggedIn } = useContext(AuthContext);
  console.log("🔍 Navigation Debug - isLoggedIn:", isLoggedIn);
  return <>{isLoggedIn && <DrawerNav />}</>;
};
